import { AddCircle, ContactSupportOutlined } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { createContext, useEffect, useState } from 'react'
import { ModalAgregaTipoActivoComponent } from '../../components/activos/ModalAgregaTipoActivoComponent'
import { ModalEliminaTipoActivoComponent } from '../../components/activos/ModalEliminaTipoActivoComponent'
import { TablaTiposActivo } from '../../components/activos/TablaTiposActivo'
import { ObtenerTiposActivo } from '../../helpers/ActivosHelper'

export const TiposActivoContext = createContext();
export const ActivosTipoPage = () => {
  const [tiposActivo, setTiposActivo] = useState();
  const [modalAgregaTipoActivo, setModalAgregaTipoActivo] = useState(false);
  const [modalEliminaTipoActivo, setModalEliminaTipoActivo] = useState(false);
  const [tipoActivoSel, setTipoActivoSel] = useState();

  useEffect(() => {
    obtenerTipos();
  }, [])

  const obtenerTipos =() => {
    ObtenerTiposActivo().then(datos=>setTiposActivo(datos))

  }
  
  useEffect(() => {
    console.log('Tipos de activo', tiposActivo)
  }, [tiposActivo])
  

  return (
    <TiposActivoContext.Provider value={{modalAgregaTipoActivo, setModalAgregaTipoActivo,obtenerTipos,
      modalEliminaTipoActivo, setModalEliminaTipoActivo, tipoActivoSel, setTipoActivoSel
    }}>
    <div
        style={{
          display:'flex',
          flexDirection:'column',
          flex:1,
            color:'black',
            marginTop:10,
            marginLeft:40,
            marginRight:20
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row',
          justifyContent:'space-between',
          maxWidth:700
        }}
      >

        <span
            style={{
              fontSize:40,
              fontWeight:'bold'
            }}
            >
            Tipos de Instalación
        </span>
        <span
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
          }}
        >
          <IconButton
            onClick={() => { setTipoActivoSel(); setModalAgregaTipoActivo(true)}}
          >
            <AddCircle style={{color:'#60318A'}} color="#60318A" />
            Agregar
          </IconButton>
        </span>
      </div>
        <span
            style={{
            fontSize:28,
            fontWeight:'regular',
            marginLeft:10,
            maxWidth:900
            }}
        >
          <TablaTiposActivo tiposActivo={tiposActivo} />
        </span>
    </div>   
    <ModalAgregaTipoActivoComponent />
    <ModalEliminaTipoActivoComponent />
    </TiposActivoContext.Provider> 
  )
}
